import { doc, updateDoc, increment } from "firebase/firestore";
import { db } from "../libs/firebaseConfig";

export async function bumpVideoView(videoId, ttlMs = 24 * 60 * 60 * 1000) {
  const key = `vid_viewed_${videoId}`;
  const last = Number(localStorage.getItem(key) || 0);
  const now = Date.now();

  if (now - last < ttlMs) return;

  localStorage.setItem(key, String(now));
  await updateDoc(doc(db, "videos", videoId), { viewCounts: increment(1) });
}